import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue";
import { useRegionArea } from '../../use';
import { watch } from 'vue';

import { reactive, unref, toRaw } from 'vue';
export default {
  __name: 'mg-area-select',
  props: {
    provinceId: {
      type: [String, Number],
      default: ''
    },
    cityId: {
      type: [String, Number],
      default: ''
    },
    countyId: {
      type: [String, Number],
      default: ''
    },
    modelValue: {
      type: Object,
      default: null
    },
    showCounty: {
      type: Boolean,
      default: true
    },
    showCity: {
      type: Boolean,
      default: true
    },
    readonly: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    clearable: {
      type: Boolean,
      default: false
    },
    filterable: {
      type: Boolean,
      default: false
    },
    vertical: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update:provinceId', 'update:cityId', 'update:countyId', 'update:modelValue', 'changed'],
  setup(__props, {
    emit: __emit
  }) {
    const emit = __emit;
    const props = __props;
    const {
      provinceList,
      cityList,
      countyList,
      area
    } = useRegionArea();
    const events = reactive({
      handleProvinceChanged() {
        emit('update:provinceId', area.provinceId);
        emit('update:modelValue', unref(area));
        emit('changed', area);
      },
      handleCityChanged() {
        emit('update:cityId', area.cityId);
        emit('update:modelValue', unref(area));
        emit('changed', area);
      },
      handleCountyChanged() {
        emit('update:countyId', area.countyId);
        emit('update:modelValue', unref(area));
        emit('changed', area);
      }
    });
    watch(() => props.provinceId, val => {
      area.provinceId = val;
    }, {
      immediate: true
    });
    watch(() => props.cityId, val => {
      area.cityId = val;
    }, {
      immediate: true
    });
    watch(() => props.countyId, val => {
      area.countyId = val;
    }, {
      immediate: true
    });
    watch(() => props.modelValue, val => {
      Object.assign(area, toRaw(unref(val || {})));
    }, {
      immediate: true,
      deep: true
    });
    return (_ctx, _cache) => {
      const _component_vxe_select = _resolveComponent("vxe-select");
      return _openBlock(), _createElementBlock("div", {
        class: _normalizeClass(['mg-area-select-wrapper', {
          'is--horizontal': !__props.vertical,
          'is--vertical': __props.vertical
        }])
      }, [_createVNode(_component_vxe_select, {
        disabled: __props.disabled,
        readonly: __props.readonly,
        options: _unref(provinceList),
        clearable: __props.clearable,
        filterable: __props.filterable,
        modelValue: _unref(area)['provinceId'],
        "onUpdate:modelValue": [_cache[0] || (_cache[0] = $event => _unref(area)['provinceId'] = $event), _unref(events).handleProvinceChanged],
        placeholder: "请选择省份"
      }, null, 8, ["disabled", "readonly", "options", "clearable", "filterable", "modelValue", "onUpdate:modelValue"]), __props.showCity ? (_openBlock(), _createBlock(_component_vxe_select, {
        key: 0,
        placeholder: "请选择州(市)",
        readonly: __props.readonly,
        disabled: !__props.provinceId && !_unref(area)['provinceId'] || __props.disabled,
        options: _unref(cityList),
        clearable: __props.clearable,
        filterable: __props.filterable,
        modelValue: _unref(area)['cityId'],
        "onUpdate:modelValue": [_cache[1] || (_cache[1] = $event => _unref(area)['cityId'] = $event), _unref(events).handleCityChanged]
      }, null, 8, ["readonly", "disabled", "options", "clearable", "filterable", "modelValue", "onUpdate:modelValue"])) : _createCommentVNode("", true), __props.showCounty ? (_openBlock(), _createBlock(_component_vxe_select, {
        key: 1,
        placeholder: "请选择区(县)",
        readonly: __props.readonly,
        disabled: !__props.cityId && !_unref(area)['cityId'] || __props.disabled,
        options: _unref(countyList),
        clearable: __props.clearable,
        filterable: __props.filterable,
        modelValue: _unref(area)['countyId'],
        "onUpdate:modelValue": [_cache[2] || (_cache[2] = $event => _unref(area)['countyId'] = $event), _unref(events).handleCountyChanged]
      }, null, 8, ["readonly", "disabled", "options", "clearable", "filterable", "modelValue", "onUpdate:modelValue"])) : _createCommentVNode("", true)], 2);
    };
  }
};